/*eslint-disable*/
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink as NavLinkRRD, Link, Route } from "react-router-dom";
import {
  getMe,
  getMeAuth,
  getAllProperties,
} from "../../utils/store/actions/users.actions";
// nodejs library to set properties for components

// reactstrap components
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { URL_SERVICE_PERSON } from "../../utils/uri";
import SidebarDropdownItem from "./SidebarDropdownItem";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import {
  ClickAwayListener,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { withTranslation } from "react-i18next";

class Sidebar extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      collapseOpen: false,
      logoUrl: "",
      tooltipOpen: false,
    };
    this.activeRoute.bind(this);
  }
  componentDidMount() {
    axios
      .get(`${URL_SERVICE_PERSON}/service-person/v1/properties/logo`)
      .then((res) => this.setState({ logoUrl: res.data.value }))
      .catch(() => {});
    this.props
      .getMe()
      .then(() =>
        this.props.getAllProperties().then(() => this.props.getMeAuth())
      );
  }
  activeRoute(routeName: string) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen,
    });
  };
  closeCollapse = () => {
    this.setState({
      collapseOpen: false,
    });
  };
  createLinks = (routes: any) => {
    const userRight =
      (this.props.LocalUser &&
        this.props.LocalUser.role &&
        this.props.LocalUser.role.userCanView &&
        this.props.LocalUser.role.teamCanView &&
        this.props.LocalUser.role.defaultAuthorizationCanView) ||
      (this.props.Users?.get_properties &&
        this.props.Users.get_properties.find(
          (property: { key: string; value: boolean }) =>
            property.key === "IS_V4_AVAILABLE"
        )?.value === "true");
    const supervisor =
      (this.props.LocalUser &&
        this.props.LocalUser.role &&
        this.props.LocalUser.role.userCanView &&
        this.props.LocalUser.role.teamCanView &&
        this.props.LocalUser.role.defaultAuthorizationCanView &&
        this.props.LocalUser.role.adminCanEditProduct &&
        this.props.LocalUser.role.adminCanEditQuestionnaire &&
        this.props.LocalUser.role.adminCanEditDocuments &&
        this.props.LocalUser.role.adminCanEditRisk &&
        this.props.LocalUser.role.adminCanEditConfiguration) ||
      (this.props.Users?.get_properties &&
        this.props.Users.get_properties.find(
          (property: { key: string; value: boolean }) =>
            property.key === "IS_V4_AVAILABLE"
        )?.value === "true");

    return routes.map((prop: any, key: any) => {
      if ("subMenu" in prop) {
        return <SidebarDropdownItem key={key} {...prop} />;
      }
      if (
        prop.name !== "Fund details" &&
        prop.name !== "Part details" &&
        prop.name !== "Questionnaire details" &&
        (userRight || supervisor)
      ) {
        switch (prop.path) {
          case "/risk-profile":
            if (supervisor) {
              return (
                <NavItem key={key}>
                  <NavLink
                    to={prop.layout + prop.path}
                    tag={NavLinkRRD}
                    onClick={this.closeCollapse}
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    {prop.name}
                  </NavLink>
                </NavItem>
              );
            }
            break;
          case "/configurations":
            if (supervisor) {
              return (
                <NavItem key={key}>
                  <NavLink
                    to={prop.layout + prop.path}
                    tag={NavLinkRRD}
                    onClick={this.closeCollapse}
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    {prop.name}
                  </NavLink>
                </NavItem>
              );
            }
            break;
          case "/questionnaires":
            if (supervisor) {
              return (
                <NavItem key={key}>
                  <NavLink
                    to={prop.layout + prop.path}
                    tag={NavLinkRRD}
                    onClick={this.closeCollapse}
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    {prop.name}
                  </NavLink>
                </NavItem>
              );
            }
            break;
          default:
            return (
              <NavItem key={key}>
                <NavLink
                  to={prop.layout + prop.path}
                  tag={NavLinkRRD}
                  onClick={this.closeCollapse}
                  activeClassName="active"
                >
                  <i className={prop.icon} />
                  {prop.name}
                </NavLink>
              </NavItem>
            );
        }
      }
    });
  };
  render() {
    const { bgColor, routes, logo } = this.props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link,
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank",
      };
    }
    return (
      <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
        width="3vh"
      >
        <Container fluid>
          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={this.toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          {logo ? (
            <NavbarBrand className="pt-0" {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={this.state.logoUrl}
              />
            </NavbarBrand>
          ) : null}
          {/* User */}
          <Nav className="align-items-center d-md-none">
            <UncontrolledDropdown nav>
              <DropdownToggle nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle"></span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem divider />
                <DropdownItem
                  href="#pablo"
                  onClick={(e: { preventDefault: () => any }) =>
                    e.preventDefault()
                  }
                >
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          {/* Collapse */}
          <Collapse navbar isOpen={this.state.collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={this.state.logoUrl} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={this.state.logoUrl} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={this.toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Form */}
            <Form className="mt-4 mb-3 d-md-none">
              <InputGroup className="input-group-rounded input-group-merge">
                <Input
                  aria-label="Search"
                  className="form-control-rounded form-control-prepended"
                  placeholder="Search"
                  type="search"
                />
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <span className="fa fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Form>
            {/* Navigation */}
            <Nav navbar>{this.createLinks(routes)}</Nav>
          </Collapse>
        </Container>
        <ClickAwayListener
          onClickAway={() => this.setState({ tooltipOpen: false })}
        >
          <Tooltip
            open={this.state.tooltipOpen}
            PopperProps={{
              disablePortal: true,
            }}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              height: "5vh",
              fontSize: "9px",
            }}
            title={
              <React.Fragment>
                <Typography color="inherit">
                  {this.props.t("SUPPORT")}
                </Typography>
                {this.props.t("CONTACT_US_MESSAGE")}
                <br />
                <button>
                  <a
                    href={`mailto:${
                      this.props.Users?.get_properties?.find(
                        (property: { key: string; value: boolean }) =>
                          property.key === "DPO_EMAIL_ADDRESS"
                      )?.value || "support@b4finance.com"
                    }`}
                  >
                    {(this.props.Users?.get_properties &&
                      this.props.Users.get_properties.find(
                        (property: { key: string; value: boolean }) =>
                          property.key === "DPO_EMAIL_ADDRESS"
                      )?.value) ||
                      "support@b4finance.com"}
                  </a>
                </button>
                <br />
                <br />
                <div>Version: {process.env.REACT_APP_VERSION}</div>
              </React.Fragment>
            }
          >
            <IconButton onClick={() => this.setState({ tooltipOpen: true })}>
              <ContactSupportIcon />
            </IconButton>
          </Tooltip>
        </ClickAwayListener>
      </Navbar>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = { getMe, getMeAuth, getAllProperties };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Sidebar));
